export default "__VITE_ASSET__ptIS5Dmc__"